import styled from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';
import { TableView } from 'modules/core/enums';

import { SelectCell } from '../../plugins/styles';

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${COLORS.WHITE};
  width: 100%;
  color: ${COLORS.GREY_3};
  text-transform: capitalize;
  height: 25px;
  min-height: 25px;
  font-weight: 700;
`;

export const CardDescription = styled.div`
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  padding: 8px 0 10px;
`;

export const CardRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-top: 1px solid ${COLORS.GREY_25};
  height: 25px;
  align-items: center;
  padding: 15px 0;

  span:first-child {
    color: ${COLORS.BLACK};
    font-weight: 500;
  }
`;

export const BadgeContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
`;

export const ColorBadgeWrapper = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
`;

export const CardCheckbox = styled.div`
  display: flex;
  align-items: center;

  ${SelectCell} {
    margin: 0;
    padding-top: 0;
    min-height: unset;
  }
`;

export const Card = styled.div<{ tableView: TableView }>`
  width: 302px;
  height: ${({ tableView }) => (tableView === TableView.SALESPERSON ? '430px' : '403px')};
  padding: 14px 25px 20px;
  background-color: ${COLORS.WHITE};
  margin: 0 15px 15px 15px;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 15px;
  position: relative;
  border: 1px solid ${COLORS.GREY_25};
  border-radius: 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08), 0px 8px 24px rgba(0, 0, 0, 0.08);

  ${CardRow}:last-child {
    border-bottom: 1px solid ${COLORS.GREY_25};
  }
`;

export const CardImageContainer = styled.div`
  position: relative;

  img {
    height: 191px;
    width: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
`;
